// extracted by mini-css-extract-plugin
module.exports = {"subTitleTagsContainer":"style_subTitleTagsContainer__3hHpp","split":"style_split__3Bii4"};